<div [ngSwitch]="notification?.type" *ngFor="let notification of notifications">
  <dgl-notification [notification]="notification" (closeMessage)="removeNotification($event)"></dgl-notification>
</div>
